import { render, staticRenderFns } from "./FamiliasForm.vue?vue&type=template&id=9b4511d2&scoped=true"
import script from "./FamiliasForm.vue?vue&type=script&lang=js"
export * from "./FamiliasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4511d2",
  null
  
)

export default component.exports